<mat-accordion>

    <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Turma
            </mat-panel-title>
        </mat-expansion-panel-header>

        <cadastrar-turmas-planejamento-oficina #cadastrarTurmasPlanejamentoOficina [planejamentoOficina]="planejamentoOficina">
        </cadastrar-turmas-planejamento-oficina>
    </mat-expansion-panel>


    <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="listarTurmasPlanejamentosOficinas.carregarLista()"
        (closed)="openFormCadastro = true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Lista de Turmas ( {{planejamentoOficina.turmasPlanejamentosOficinas?.length}} )
            </mat-panel-title>
        </mat-expansion-panel-header>

        <listar-turmas-planejamento-oficina #listarTurmasPlanejamentosOficinas
                          [turmasPlanejamentosOficinas]="planejamentoOficina.turmasPlanejamentosOficinas"
                          (onAtualizarTurma)="onGetAdicionar($event); cadastrarTurmasPlanejamentoOficina.atualizarTurma($event)"
                          (onAdicionar)="onGetAdicionar($event); cadastrarTurmasPlanejamentoOficina.cancelar()">
        </listar-turmas-planejamento-oficina>

    </mat-expansion-panel>


</mat-accordion>
